import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'home' }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/Register.vue')
    },
    {
      path: '/doc/overview',
      component: () => import('@/views/doc/DocList.vue'),
      children: [
        {
          path: ':uni',
          name: 'docOverView',
          component: () => import('@/views/doc/DocOverView.vue')
        },
        {
          path: ':uni/:id',
          name: 'docDetail',
          component: () => import('@/views/doc/DocDetail.vue')
        }
      ]
    },
    {
      path: '/doc/coupon',
      component: () => import('@/views/doc/DocList.vue'),
      children: [
        {
          path: '',
          name: 'couponDocOverView',
          component: () => import('@/views/doc/DocOverView.vue')
        },
        {
          path: ':id',
          name: 'couponDocDetail',
          component: () => import('@/views/doc/DocDetail.vue')
        }
      ]
    },
    {
      path: '/doc/order',
      component: () => import('@/views/doc/DocList.vue'),
      children: [
        {
          path: '',
          name: 'orderDocOverView',
          component: () => import('@/views/doc/DocOverView.vue')
        },
        {
          path: ':id',
          name: 'orderDocDetail',
          component: () => import('@/views/doc/DocDetail.vue')
        }
      ]
    },
    {
      path: '/doc/qrpay',
      component: () => import('@/views/doc/DocList.vue'),
      children: [
        {
          path: '',
          name: 'qrpayDocOverview',
          component: () => import('@/views/doc/DocOverView.vue')
        },
        {
          path: ':id',
          name: 'qrpayDocDetail',
          component: () => import('@/views/doc/DocDetail.vue')
        }
      ]
    },
    {
      path: '/doc/shop',
      component: () => import('@/views/doc/DocList.vue'),
      children: [
        {
          path: '',
          name: 'shopDocOverView',
          component: () => import('@/views/doc/DocOverView.vue')
        },
        {
          path: ':id',
          name: 'shopDocDetail',
          component: () => import('@/views/doc/DocDetail.vue')
        }
      ]
    },
    {
      path: '/doc/product',
      component: () => import('@/views/doc/DocList.vue'),
      children: [
        {
          path: '',
          name: 'productDocOverView',
          component: () => import('@/views/doc/DocOverView.vue')
        },
        {
          path: ':id',
          name: 'productDocDetail',
          component: () => import('@/views/doc/DocDetail.vue')
        }
      ]
    },
    {
      path: '/doc/help',
      component: () => import('@/views/doc/DocList.vue'),
      children: [
        {
          path: '',
          name: 'helpDocOverView',
          component: () => import('@/views/doc/DocOverView.vue')
        },
        {
          path: ':id',
          name: 'helpDocDetail',
          component: () => import('@/views/doc/DocDetail.vue')
        }
      ]
    },
    {
      path: '/admin/',
      component: () => import('@/views/developer/Developer.vue'),
      children: [
        {
          path: '',
          name: 'developerOverview',
          component: () => import('@/views/developer/DeveloperOverview.vue')
        },
        {
          path: 'account',
          name: 'accountDetail',
          component: () => import('@/views/developer/info/AccountDetail.vue')
        },
        {
          path: 'vendor',
          name: 'vendorDetail',
          component: () => import('@/views/developer/info/VendorDetail.vue')
        },
        {
          path: 'application',
          name: 'vendorApplication',
          component: () => import('@/views/developer/info/VendorApplication.vue')
        },
        {
          path: 'permission',
          name: 'vendorPermission',
          component: () => import('@/views/developer/info/VendorPermission2.vue')
        },
        {
          path: 'audit',
          name: 'audit',
          component: () => import('@/views/developer/Audit.vue')
        },
        {
          path: 'applyPermission',
          name: 'applyPermission',
          component: () => import('@/views/developer/setting/ApplyPermission.vue')
        },
        {
          path: 'callbackUrl',
          name: 'callbackUrl',
          component: () => import('@/views/developer/setting/CallbackUrl.vue')
        },
        {
          path: 'apiTestTool',
          name: 'apiTestTool',
          component: () => import('@/views/developer/tool/ApiTestTool.vue')
        },
        {
          path: 'testShopDetail',
          name: 'testShopDetail',
          component: () => import('@/views/developer/tool/TestShopDetail.vue')
        },
        {
          path: 'signCheck',
          name: 'signCheck',
          component: () => import('@/views/developer/tool/SignCheck.vue')
        },
        {
          path: 'callbackCheck',
          name: 'callbackCheck',
          component: () => import('@/views/developer/tool/CallbackCheck.vue')
        },
        {
          path: 'sandBoxBizConfig',
          name: 'sandBoxBizConfig',
          component: () => import('@/views/developer/tool/SandBoxBizConfig.vue')
        },
        {
          path: 'sandBoxSelfTest',
          name: 'sandBoxSelfTest',
          component: () => import('@/views/developer/tool/SandBoxSelfTest.vue')
        }
      ]
    },
    {
      path: '/account',
      component: () => import('@/views/account/Account.vue'),
      children: [
        {
          path: 'name',
          name: 'accountName',
          component: () => import('@/views/account/AccountName.vue')
        },
        {
          path: 'password',
          name: 'accountPassword',
          component: () => import('@/views/account/AccountPassword.vue')
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js